import React, { useEffect, useMemo } from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { get, getOr } from 'lodash/fp';

import { useParams } from 'react-router-dom';
import { FETCH_UNAPPROVE_SCHOOLS_BY_EVENT, FETCH_EVENT } from '../../GraphQL/Queries';
import useCurrentUser from '../../Hooks/userCurrentUser';
import Loader from '../../Components/Loader';
import useGraphQLErrorExtractor from '../../Hooks/useGraphQLErrorExtractor';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import GenericAlert from '../../Components/GenericAlert';
import NestedList from '../../Components/NestedList/Index';
import { EVENT_TITLE } from '../../Constants/AppConstants';
import useFilterArray from '../../Hooks/useFilterArray';

const ActiveSchoolsByEvent = () => {
  const {
    currentUser,
    error: userError,
  } = useCurrentUser(null);

  const extractError = useGraphQLErrorExtractor();
  const { id } = useParams();
  const filterArray = useFilterArray();
  const [fetchUnapproveSchool, { loading, error, data: dataSchools }] = useLazyQuery(
    FETCH_UNAPPROVE_SCHOOLS_BY_EVENT,
  );

  const schools = useMemo(() => filterArray((getOr([], 'fetchUnapproveSchool', dataSchools)), 'status', 'active'), [dataSchools, filterArray]);

  const { data } = useQuery(
    FETCH_EVENT,
    {
      variables: { id: parseInt(id, 10) },
    },
  );
  const event = getOr({}, 'fetchEventDetail', data);

  useHeaderComponentsMutation({
    title: 'UNAPPROVED TEAMS',
    backLink: `/event-manage/${id}`,
    components: [{ key: EVENT_TITLE, value: event.title }],
  });

  useEffect(() => {
    if (currentUser) {
      fetchUnapproveSchool({
        variables: {
          eventId: parseInt(id, 10),
        },
      });
    }
  }, [currentUser, fetchUnapproveSchool, id]);

  if (loading) {
    return <Loader />;
  }
  if (error || userError) {
    return <GenericAlert>{extractError(error)}</GenericAlert>;
  }

  return (
    <div className="row py-5">
      <div className="col-12 mx-auto px-4">
        <p className="d-none">{get('firstname', currentUser)}</p>
        {schools.length === 0
          ? <p>No Schools</p>
          : null}
        <NestedList data={schools} displayAttribute="name" redirectLink="event-manage" redirectOperation="team-captains-by-school" dataType="schools" optionalId={id} />
      </div>
    </div>
  );
};

export default ActiveSchoolsByEvent;
